// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"c2d57487","201":"a90bce54","848":"7154eb68","921":"65dd86a6"}[chunkId] + ".chunk.js";
};